export const INVITE_RULES = {
  items: [
    "购买指定产品后可获得推广资格",
    "邀请码用于建立邀请关系，不改变本单金额。",
    "邀请关系未建立，请确认订单条件后重试。",
    "RMB 一级金额按数据库规则版本执行",
    "二级关系可派生，现金 payout 为 0",
    "订单完成并超过售后期后转为可提现",
    "退款、取消、异常交易不计佣",
  ],
  note: "前端文案仅作解释，后端规则以数据库规则版本为准。",
  closeLabel: "知道了",
} as const;
